/* SelfAbout — mobile drawer collections (live /collections.json) */
(function () {
  var SKIP = {
    all: 1,
    frontpage: 1,
    bundles: 1,
    shop: 1,
    "all-accessories": 1,
    catalog: 1,
  };
  var EMOJI_KEYS = [
    [/hat|cap/i, "🧢"],
    [/water|bottle/i, "💧"],
    [/pouch|mobile|phone/i, "📱"],
    [/earbud|earphone|headphone|audio/i, "🎧"],
    [/watch|smart.?watch/i, "⌚"],
    [/bundle|kit/i, "✨"],
    [/bag|carry/i, "🎒"],
  ];
  var cache = null;
  var fetching = false;

  function emojiFor(handle, title) {
    var s = String(handle || "") + " " + String(title || "");
    for (var i = 0; i < EMOJI_KEYS.length; i++) {
      if (EMOJI_KEYS[i][0].test(s)) return EMOJI_KEYS[i][1];
    }
    return "📦";
  }

  function navBusy() {
    return !!window.__saDrawerNavDest;
  }

  function fill(ul, cols) {
    if (!ul) return;
    if (navBusy()) return;
    while (ul.firstChild) ul.removeChild(ul.firstChild);
    var path = (location.pathname || "").toLowerCase();
    for (var i = 0; i < cols.length; i++) {
      var c = cols[i];
      var handle = String(c.handle || "").toLowerCase();
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = "/collections/" + handle;
      a.className = "sa-drawer-sublink";
      a.setAttribute("data-sa-drawer-nav", "1");
      if (path.indexOf("/collections/" + handle) === 0) {
        a.className += " sa-drawer-sublink--active";
      }
      var icon = document.createElement("span");
      icon.className = "sa-drawer-sublink__icon";
      icon.textContent = emojiFor(handle, c.title);
      var text = document.createElement("span");
      text.className = "sa-drawer-sublink__text";
      text.textContent = c.title || handle;
      a.appendChild(icon);
      a.appendChild(text);
      li.appendChild(a);
      ul.appendChild(li);
    }
    var allLi = document.createElement("li");
    var allA = document.createElement("a");
    allA.href = "/collections";
    allA.className = "sa-drawer-sublink sa-drawer-sublink--all";
    allA.setAttribute("data-sa-drawer-nav", "1");
    var allIcon = document.createElement("span");
    allIcon.className = "sa-drawer-sublink__icon";
    allIcon.textContent = "🌟";
    var allText = document.createElement("span");
    allText.className = "sa-drawer-sublink__text";
    allText.textContent = "View All Collections →";
    allA.appendChild(allIcon);
    allA.appendChild(allText);
    allLi.appendChild(allA);
    ul.appendChild(allLi);
    ul.setAttribute("data-sa-filled", "1");
  }

  function normalize(nodes) {
    var cols = [];
    for (var i = 0; i < nodes.length; i++) {
      var c = nodes[i];
      var handle = String((c && c.handle) || "").toLowerCase();
      if (!handle || SKIP[handle]) continue;
      if (typeof c.products_count === "number" && c.products_count === 0) continue;
      cols.push({
        title: c.title || handle,
        handle: handle,
        published: Date.parse(c.published_at || 0) || 0,
        id: Number(c.id) || 0,
      });
    }
    cols.sort(function (a, b) {
      if (b.published !== a.published) return b.published - a.published;
      if (b.id !== a.id) return b.id - a.id;
      return String(a.title).localeCompare(String(b.title));
    });
    return cols.slice(0, 40);
  }

  function applyAll(cols, force) {
    var lists = document.querySelectorAll("[data-sa-drawer-collections]");
    for (var i = 0; i < lists.length; i++) {
      if (!force && lists[i].getAttribute("data-sa-filled") === "1") continue;
      fill(lists[i], cols);
    }
  }

  function load(force) {
    if (!force && navBusy()) return;
    if (cache && !force) {
      applyAll(cache, false);
      return;
    }
    if (fetching) return;
    fetching = true;
    fetch("/collections.json?limit=250", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      cache: "no-store",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("collections " + r.status);
        return r.json();
      })
      .then(function (data) {
        cache = normalize((data && data.collections) || []);
        applyAll(cache, !!force);
      })
      .catch(function () {
        cache = cache || [];
        applyAll(cache, !!force);
      })
      .finally(function () {
        fetching = false;
      });
  }

  function boot() {
    load(false);
    var tries = 0;
    var t = window.setInterval(function () {
      tries += 1;
      var pending = document.querySelector(
        "[data-sa-drawer-collections]:not([data-sa-filled='1'])",
      );
      if (pending) load(false);
      if (!pending || tries > 40) window.clearInterval(t);
    }, 250);
  }

  document.addEventListener(
    "toggle",
    function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains("menu-drawer-container")) return;
      if (t.open || t.classList.contains("menu-open")) {
        if (
          document.querySelector(
            "[data-sa-drawer-collections]:not([data-sa-filled='1'])",
          )
        ) {
          load(false);
        }
      }
    },
    true,
  );

  var mo = new MutationObserver(function () {
    if (!document.documentElement.classList.contains("sa-menu-open")) return;
    if (
      document.querySelector(
        "[data-sa-drawer-collections]:not([data-sa-filled='1'])",
      )
    ) {
      load(false);
    }
  });
  mo.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
